<nav class="navbar navbar-expand-xxl navbar-light mb-3">
  <div class="container-fluid flex-column flex-xxl-row">
    <div class="d-flex justify-content-between align-items-center w-sm-100 w-xxl-auto">
      <div class="logos text-center">
        <a
          href="https://www.regione.toscana.it/"
          target="_blank"
          class="mr-4"
        >
          <img
            src="/assets/images/loghi/logo_regione.png"
            alt="Regione Toscana"
          />
        </a>
        <a
          href="https://www.regione.toscana.it/sst"
          target="_blank"
          class="mr-4"
        >
          <img
            src="/assets/images/loghi/logo_asl_cut.png"
            alt="Sistema Sanitario della Toscana - MANAGEMENT E SANITÀ"
          />
        </a>
      </div>
      <div>
        <button
          class="navbar-toggler"
          type="button"
          style="height: 40px"
          (click)="isCollapsed = !isCollapsed"
        >
          &#9776;
        </button>
      </div>
    </div>
    <div class="flex-grow-1 flex-xxl-grow-0">
      <div
        [ngbCollapse]="isCollapsed"
        class="collapse navbar-collapse"
      >
        <ul
          class="nav navbar-nav navbar-right d-block d-xxl-flex"
        >
          <li
            class="nav-item"
            [class.my-1]="!isCollapsed"
          ><a
              [class.mx-0]="!isCollapsed"
              target="blank"
              href="https://celiachia.sanita.toscana.it"
              class="icon cel wow fadeIn text-center"
              style="visibility: visible; animation-name: fadeIn;"
            ><b>&gt;</b> Celiachia</a></li>
          <li
            class="nav-item"
            [class.my-1]="!isCollapsed"
          ><a
              [class.mx-0]="!isCollapsed"
              target="blank"
              href="https://zerocode.sanita.toscana.it"
              class="zero  wow fadeIn text-center"
              style="visibility: visible; animation-name: fadeIn;"
            ><b>&gt;</b> ZERO Code</a></li>
          <li
            class="nav-item"
            [class.my-1]="!isCollapsed"
          ><a
              [class.mx-0]="!isCollapsed"
              target="blank"
              href="https://televisita.sanita.toscana.it"
              class="tele wow fadeIn text-center"
              style="visibility: visible; animation-name: fadeIn;"
            ><b>&gt;</b> Televisita</a></li>
          <li
            class="nav-item"
            [class.my-1]="!isCollapsed"
          ><a
              [class.mx-0]="!isCollapsed"
              target="blank"
              href="https://prenota.sanita.toscana.it"
              class="cup wow fadeIn text-center"
              style="visibility: visible; animation-name: fadeIn;"
            ><b>&gt;</b> CUP online</a></li>
          <li class="nav-item"><a
              [class.mx-0]="!isCollapsed"
              target="blank"
              href=" https://fascicolosanitario.regione.toscana.it/"
              class="fascicolo wow fadeIn text-center"
              style="visibility: visible; animation-name: fadeIn;"
            ><b>&gt;</b> Fascicolo sanitario</a></li>
        </ul>
      </div>
    </div>

  </div>
</nav>
